import { apiErrorCodes } from '../../utils/apiHelper'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { getPatientChart } from '../charts/ChartsThunk'

export const getErrorMessage = (action: any, patientId: string, tabId: string) => {
  const errorCode = action.payload.ErrorCode
  if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
    return action.payload.UserFriendlyErrorCode ?
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
      : ''
  }
  switch (errorCode) {
    case apiErrorCodes.ITEM_NOT_FOUND:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'Product')
    case apiErrorCodes.VISIT_NOT_FOUND:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'Visit')
    case apiErrorCodes.ITEM_COUNT_NOT_VALID:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Number of products')
    case apiErrorCodes.ITEM_NOT_UNIQUE:
      return getUserFriendlyErrorMessage(errorCodes.DUPLICATE_OPTIONS)
    case apiErrorCodes.CREDIT_AMOUNT_NOT_VALID:
      getPatientChart(patientId, tabId)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Credit amount')
    case apiErrorCodes.PHARMACY_PICKUP_NOT_ALLOWED:
    case apiErrorCodes.PHARMACY_NOT_VALID:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Pharmacy')
    case apiErrorCodes.SHIPPING_ADDRESS_NOT_VALID:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'shipping address')
    case apiErrorCodes.REFILLS_QUANTITY_NOT_VALID:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Refills value')
    case apiErrorCodes.SIGNATURE_NOT_VALID:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Signature')
    case apiErrorCodes.EARLIEST_FILL_DATE_NOT_VALID:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Fill date')
    case apiErrorCodes.DURATION_DAYS_NOT_VALID:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Duration')
    case apiErrorCodes.PHARMACY_NOT_FOUND:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'Pharmacy')
    case apiErrorCodes.DRUG_OPTION_NOT_FOUND:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'Drug')
    default:
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)
  }
}
